import { createSlice } from "@reduxjs/toolkit";
import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";


const initialState = {
    data: null,
};

export const paymentSlice = createSlice({
    name: "payment",
    initialState,
    reducers: {
        setPayment: (state) => {
            state.data = state.payload;
        },
    },
});

// Action creators are generated for each case reducer function
export const { setPayment } = paymentSlice.actions;

export default paymentSlice.reducer;

const apiUrl = process.env.REACT_APP_PROXY_URL || "http://localhost:3008/api";
const orangeApiKey = process.env.REACT_APP_API_KEY 

export const paymentApi = createApi({
    reducerPath: "paymentApi",
    baseQuery: fetchBaseQuery({
        baseUrl: apiUrl, // Utilisation du proxy
        prepareHeaders: (headers, { getState }) => {
            const token = JSON.parse(localStorage.getItem('auth'))?.jwt;

            // Si un token est disponible, ajoutez-le aux en-têtes
            if (token) {
                headers.set("authorization", `Bearer ${token}`);
            }
            headers.set('Content-type', 'application/json');
            headers.set('Accept', 'application/json');
            return headers;
        },
    }),
    endpoints: (builder) => ({
        getToken: builder.mutation({
            query: (data) => ({
                url: `/fetch?endpoint=oauth/v3/token`, // Appel via le proxy
                method: "GET",
                headers: {
                    "Authorization": orangeApiKey, // Utilisation de la clé API pour l'authentification
                }
            }),
        }),

        postPaymentMorale: builder.mutation({
            query: (data) => ({
                url: '/fetch?endpoint=orange-money-webpay/dev/v1/webpayment', // Appel via le proxy
                method: 'POST',
                body: data,
            }),
        }),
        postPayment: builder.mutation({
            query: (data) => ({
                url: 'https://apibumda.nta-technologie.com/api/paiements', // Appel via le proxy
                method: 'POST',
                body: data,
            }),
        }),
        getPayments: builder.query({
            query: (id) => ({
                url: `https://apibumda.nta-technologie.com/api/paiements?populate=*&sort=createdAt:desc`,
                method: 'GET',
            }),
        }),
        getPaymentById: builder.query({
            query: (id) => ({
                url: `https://apibumda.nta-technologie.com/api/paiements/${id}`,
                method: 'GET',
            }),
        }),
    }),
});

// Export hooks pour une utilisation dans les composants fonctionnels
export const { useGetTokenMutation, usePostPaymentMoraleMutation, usePostPaymentMutation, useGetPaymentsQuery, useGetPaymentByIdQuery } = paymentApi;

